import { Component, Input } from '@angular/core';

@Component({
  selector: 'apc-jira-user-creation-success',
  templateUrl: './jira-user-creation-success.component.html',
  styleUrls: ['./jira-user-creation-success.component.scss', '../jira-users.component.scss']
})
export class JiraUserCreationSuccessComponent {
  @Input() modalRef: any;
  @Input() user: any = null;
  @Input() isError: boolean = false;
  @Input() email: string = '';

  close() {
    this.modalRef.dismiss();
  }
}
